var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 32,
    viewBox: "0 0 51 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google Pay"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.5,
    width: 50,
    height: 32,
    rx: 3,
    fill: "#5485EC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.4716 16.827V21.2502H23.0684V10.3269H26.7899C27.2342 10.3176 27.6758 10.3964 28.0895 10.5587C28.5031 10.721 28.8805 10.9636 29.1998 11.2726C29.5224 11.5627 29.7791 11.9186 29.9528 12.3162C30.1264 12.7138 30.2129 13.144 30.2065 13.5778C30.2157 14.014 30.1305 14.447 29.9568 14.8472C29.783 15.2473 29.5248 15.6052 29.1998 15.8962C28.5491 16.5168 27.7458 16.8268 26.7899 16.8262H24.4716V16.827ZM24.4716 11.6717V15.4848H26.8248C27.0828 15.4925 27.3395 15.4462 27.5786 15.3489C27.8177 15.2517 28.0338 15.1056 28.2132 14.9201C28.3917 14.7466 28.5335 14.539 28.6304 14.3098C28.7272 14.0805 28.7771 13.8341 28.7771 13.5853C28.7771 13.3364 28.7272 13.09 28.6304 12.8607C28.5335 12.6315 28.3917 12.4239 28.2132 12.2505C28.0361 12.061 27.8207 11.9113 27.5813 11.8114C27.342 11.7115 27.0841 11.6636 26.8248 11.6709H24.4716V11.6717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.4402 13.5322C34.4773 13.5322 35.296 13.8094 35.8963 14.3637C36.4965 14.918 36.7963 15.678 36.7957 16.6437V21.2499H35.4535V20.2128H35.3925C34.8114 21.0669 34.0387 21.494 33.0741 21.494C32.2508 21.494 31.562 21.2499 31.0076 20.7619C30.7416 20.5379 30.5289 20.2573 30.3851 19.9407C30.2413 19.624 30.1699 19.2793 30.1762 18.9316C30.1762 18.1582 30.4684 17.5432 31.053 17.0865C31.6375 16.6298 32.4178 16.4008 33.394 16.3997C34.2272 16.3997 34.9134 16.5522 35.4526 16.8573V16.5365C35.4542 16.2995 35.403 16.065 35.3028 15.8502C35.2025 15.6354 35.0557 15.4456 34.873 15.2945C34.502 14.9597 34.0184 14.7771 33.5186 14.7829C32.7348 14.7829 32.1145 15.1135 31.6578 15.7748L30.4219 14.9965C31.1018 14.0203 32.1078 13.5322 33.4402 13.5322ZM31.6247 18.9621C31.6238 19.1407 31.6655 19.3169 31.7465 19.4761C31.8274 19.6353 31.9452 19.7728 32.0901 19.8772C32.4005 20.1213 32.7857 20.2507 33.1805 20.2433C33.7726 20.2423 34.3402 20.0066 34.7589 19.5879C35.2237 19.1503 35.4561 18.637 35.4561 18.0478C35.0186 17.6992 34.4085 17.5249 33.6258 17.5249C33.0558 17.5249 32.5805 17.6623 32.1999 17.9371C31.8156 18.216 31.6247 18.5551 31.6247 18.9621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M44.4997 13.7773L39.8142 24.5455H38.3656L40.1044 20.7778L37.0234 13.7773H38.5487L40.7755 19.1462H40.806L42.9719 13.7773H44.4997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.8014 15.8736C18.8019 15.446 18.7658 15.0191 18.6933 14.5977H12.7754V17.0145H16.1649C16.0956 17.4005 15.9487 17.7685 15.7333 18.0962C15.5179 18.424 15.2384 18.7047 14.9116 18.9215V20.4903H16.9345C18.119 19.3982 18.8014 17.7832 18.8014 15.8736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.7748 22.0059C14.4682 22.0059 15.8941 21.4498 16.9339 20.4911L14.911 18.9223C14.3479 19.304 13.6228 19.5219 12.7748 19.5219C11.138 19.5219 9.74868 18.4185 9.25188 16.9316H7.16797V18.5484C7.69027 19.5877 8.49116 20.4614 9.48123 21.072C10.4713 21.6825 11.6116 22.0058 12.7748 22.0059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.25212 16.9319C8.98948 16.1527 8.98948 15.309 9.25212 14.5298V12.9131H7.1682C6.72883 13.7874 6.5 14.7524 6.5 15.7309C6.5 16.7094 6.72883 17.6743 7.1682 18.5486L9.25212 16.9319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M12.7748 11.9395C13.6697 11.9248 14.5344 12.263 15.182 12.8807L16.9731 11.0897C15.8374 10.0229 14.3328 9.43729 12.7748 9.45549C11.6116 9.45554 10.4713 9.77889 9.48123 10.3894C8.49116 11 7.69027 11.8737 7.16797 12.913L9.25188 14.5297C9.74868 13.0429 11.138 11.9395 12.7748 11.9395Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePay);
export default __webpack_public_path__ + "static/media/google-pay.43c194887a5d45caebec028a675eb870.svg";
export { ForwardRef as ReactComponent };